import axios from 'axios';

export class VideoProcessingService {
  private static correctVideoUrl = '/api/video/correct';
  private static client = axios;

  /**
   * Sends a video file and camera ID to the backend for correction.
   * Expects the corrected video file as a Blob in the response.
   * @param videoFile The original video file.
   * @param cameraId The ID of the selected camera.
   * @returns A Promise resolving to the corrected video Blob.
   */
  static async correctVideo(videoFile: File, cameraId: string): Promise<Blob> {
    const formData = new FormData();
    formData.append('video', videoFile, videoFile.name);
    formData.append('cameraId', cameraId);

    try {
      console.log(`Sending video correction request for camera ${cameraId} to ${this.correctVideoUrl}`);
      const response = await this.client.post<Blob>(
        this.correctVideoUrl,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          responseType: 'blob', // Important: Expect a Blob response
        }
      );
      console.log('Video correction response received, type:', response.data.type, 'size:', response.data.size);
      // Basic check if the response looks like a video blob
      if (!(response.data instanceof Blob) || !response.data.type.startsWith('video/')) {
         throw new Error('Invalid response from server: Expected a video Blob.');
      }
      return response.data;
    } catch (error) {
      console.error('Fehler bei der Video-Korrektur:', error);
      // Improve error handling based on backend response if available
      if (axios.isAxiosError(error) && error.response) {
         // Attempt to read error message if response is JSON blob
         if (error.response.data instanceof Blob && error.response.data.type === 'application/json') {
           try {
             const errorJson = JSON.parse(await error.response.data.text());
             throw new Error(`Video correction failed: ${errorJson.message || 'Unknown server error'}`);
           } catch (parseError) {
              // Fallback if JSON parsing fails
              throw new Error('Video correction failed: Could not parse error response from server.');
           }
         } else {
           throw new Error(`Video correction failed: ${error.response.statusText || 'Server error'} (Status: ${error.response.status})`);
         }
      }
      // Fallback for non-Axios errors or errors without response
      throw error;
    }
  }
} 